import { cn } from '@/shared/lib/cn'
import { Container } from './container'

interface SectionProps {
  children: React.ReactNode
  className?: string
  innerClassName?: string
  id?: string
  as?: 'section' | 'div' | 'article'
  size?: 'sm' | 'default' | 'lg' | 'full'
  pad?: 'sm' | 'md' | 'lg' | 'none'
}

export function Section({
  children,
  className,
  innerClassName,
  id,
  as: Tag = 'section',
  size = 'default',
  pad = 'md',
}: SectionProps) {
  const paddings = {
    none: '',
    sm: 'py-12 sm:py-16',
    md: 'py-16 sm:py-24 lg:py-28',
    lg: 'py-24 sm:py-32 lg:py-40',
  }
  return (
    <Tag id={id} className={cn('relative', paddings[pad], className)}>
      <Container size={size} className={innerClassName}>
        {children}
      </Container>
    </Tag>
  )
}

interface SectionHeaderProps {
  eyebrow?: string
  title: React.ReactNode
  description?: React.ReactNode
  align?: 'start' | 'center'
  className?: string
}

export function SectionHeader({
  eyebrow,
  title,
  description,
  align = 'center',
  className,
}: SectionHeaderProps) {
  return (
    <div
      className={cn(
        'mb-12 sm:mb-16 max-w-3xl',
        align === 'center' && 'mx-auto text-center',
        align === 'start' && 'text-start',
        className,
      )}
    >
      {eyebrow && <span className="eyebrow mb-5">{eyebrow}</span>}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-balance">
        {title}
      </h2>
      {description && (
        <p className="mt-5 text-base sm:text-lg text-muted-foreground leading-relaxed text-pretty">
          {description}
        </p>
      )}
    </div>
  )
}
